import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module({
    namespaced: true, name: 'IntermediariesStore'
})

export default class IntermediariesStore extends VuexModule {

}